/**
 * 动态扩散圆
 */
import * as Cesium from 'cesium'
export default class DynamicRange{
    constructor(val){
        this.viewer = val.viewer;
    }
    dynamicRange(val){
        let minR= val.minR;//最小半径
        let maxR = val.maxR;// 最大半径
        let deviationR = val.deviationR; // 每次增加的大小
        var r1 = minR
        var r2 = minR+1

        function changeR1() {
            r1=r1+deviationR;//deviationR为每次圆增加的大小
            if(r1>=maxR){
                r1=minR;
            }
            return r1;

        }
        function changeR2() {
            r2=r2+deviationR;//deviationR为每次圆增加的大小
            if(r2>=maxR){
                r2=minR+1;
            }
            return r2;

        }
        function color() {
            let x=1-r1/maxR;
            return Cesium.Color.WHITE.withAlpha(x);
        }
        let entitys = this.viewer.entities.add({
            position: Cesium.Cartesian3.fromDegrees(val.item.location[0], val.item.location[1],val.item.location[2]),
            ellipse: {
                semiMinorAxis: new Cesium.CallbackProperty(changeR1,false),
                semiMajorAxis: new Cesium.CallbackProperty(changeR2,false),
                material: new Cesium.ImageMaterialProperty({
                    image:require("../assets/ring.png"),
                    repeat:new Cesium.Cartesian2(1.0, 1.0),
                    transparent:true,
                    color:new Cesium.CallbackProperty(color,false)
                }),
                outlineColor: Cesium.Color.RED
            }
        });
        return entitys
    }


    dynamicRange2(val){
        let minR= val.minR;//最小半径
        let maxR = val.maxR;// 最大半径
        let deviationR = val.deviationR; // 每次增加的大小
        var r1 = minR
        var r2 = minR+0.3

        function changeR1() {
            r1=r1+deviationR;//deviationR为每次圆增加的大小
            if(r1>=maxR){
                r1=minR;
            }
            return r1;

        }
        function changeR2() {
            r2=r2+deviationR;//deviationR为每次圆增加的大小
            if(r2>=maxR){
                r2=minR+0.3;
            }
            return r2;

        }
        function color() {
            let x=1-r1/maxR;
            return Cesium.Color.WHITE.withAlpha(x);
        }
        let entitys = this.viewer.entities.add({
            position: Cesium.Cartesian3.fromDegrees(val.item.location[0], val.item.location[1],val.item.location[2]),
            ellipse: {
                semiMinorAxis: new Cesium.CallbackProperty(changeR1,false),
                semiMajorAxis: new Cesium.CallbackProperty(changeR2,false),
                material: new Cesium.ImageMaterialProperty({
                    image:require("../assets/ring.png"),
                    repeat:new Cesium.Cartesian2(1.0, 1.0),
                    transparent:true,
                    color:new Cesium.CallbackProperty(color,false)
                }),
                outlineColor: Cesium.Color.RED
            }
        });
        return entitys
    }
}
